module.exports = __webpack_public_path__ + "img/notify_icon.ca254418.svg";